<template>
	<div class="date-square">
		<span class="date-square-month">{{ month }}</span>
		<span class="date-square-date">{{ date }}</span>
	</div>
</template>

<script>
export default {
	props: {
		date: Number,
		month: String,
	},
};
</script>

<style lang="scss" scoped>
.date-square {
	@include rem('width', 70px);
	@include rem('height', 80px);
	border: $b360-border-width-thin solid $border-color-light;
	border-radius: $b360-border-radius-base;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	padding: 10px 0;
	box-sizing: border-box;

	&.current-date {
		background-color: $highlight-color;
		border-color: $brand-blue;
	}

	&-month {
		text-transform: uppercase;
		font-size: $b360-font-size--small;
		line-height: 1;
	}

	&-date {
		@include rem('font-size', 32px);
		color: $brand-blue;
		line-height: 1;
	}
}
</style>
